import { NotifyHelper } from "../../../helpers/toast";
import { edongBoPhiKyTucXaActionsObj } from "../../action-types/dong-bo/IDongBoPhiKyTucXaAction";
import { generateActionForKey, generateActions } from "../generateActions";

export const dongBoPhiKyTucXaActions = {
  ...generateActions(edongBoPhiKyTucXaActionsObj, "DONG_BO_PHI_KY_TUC_XA"),
  ...generateActionForKey(
    edongBoPhiKyTucXaActionsObj,
    "DONG_BO_PHI_KY_TUC_XA",
    "SYNC_SUCCESS",
    (m) => {
      NotifyHelper.Success("Đồng bộ thành công");
    }
  ),
  ...generateActionForKey(
    edongBoPhiKyTucXaActionsObj,
    "DONG_BO_PHI_KY_TUC_XA",
    "SYNC_ERR",
    (m: string) => {
      NotifyHelper.Error(m || "Đồng bộ thất bại");
    }
  ),
};
